import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5aecz5f3k: FaireProductEntity = {
  token: "p_s5aecz5f3k",
  type: "product",
  name: "Cabin Time Games: Four Corners (Wholesale Pack of 4)",
  brandToken: "b_qsh7rux99c",
  brandName: "Cabin Time Games",
  imageUrl: "https://cdn.faire.com/fastly/29e6ec71ea94b3bb99111bc93651cd8053f9094cf5ecfad6663605a2a919d6f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/25d13f4d7028f747d58b2c56dc2de1a0d161290c1abae35da8fdf1e4d9ad1634.jpeg",
    "https://cdn.faire.com/fastly/ad0a328c755f659fb7b34f50d353794ae72ef9f8fbe1ba3caaa7062e9511e529.jpeg",
    "https://cdn.faire.com/fastly/17fb91956f25e6c45e0c3cf7b589180c9761e00525cd09d8e022c7b27ddff9cf.jpeg",
    "https://cdn.faire.com/fastly/c9912cefc2514df8667819e668c833ed64e9f67f2f888eba751d3776a44ba778.jpeg",
    "https://cdn.faire.com/fastly/5282756358bab2941f00894d91d5c4f28d702d0f263a203ade38fd22a0ee246f.jpeg",
    "https://cdn.faire.com/fastly/3fc30a4190d3184777707a1f02be7dbfc5c3c8a47b0362f7a6a3cd0a24cd8ad2.jpeg",
    "https://cdn.faire.com/fastly/e63d4978fc395fa53642ef9fad0b04837d1afbf057f58d8ff2fec05db5e25584.jpeg"
  ],
  priceDollars: 35.98,
  description: "Which corner will keep you in the game? Cabin Time Games: Four Corners turns the suspense of the classic group game into a screen free card game for kids and families. Choose your corner, watch the next callout, and see who stays in for another round. Quick decisions and unexpected turns keep everyone asking to play again.\n\nCreated by camp directors Allison Miller and Austin Nelson, Cabin Time Games: Four Corners was tested and refined with real campers. This portable family game is ready for game nights, vacations, classrooms, and everyday gatherings. Each boxed game includes a collectible patch.\n\nThis wholesale case contains 4 copies of Cabin Time Games: Four Corners. Suggested retail price is $17.99 per game.",
  tags: [],
  msrpDollars: 71.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:38.355Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
